import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "flex-container-row flex-item align-center justify-between",
  style: {"width":"450px","white-space":"nowrap"}
}
const _hoisted_2 = {
  key: 1,
  class: "flex-node-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_label = _resolveComponent("k-label")!
  const _component_num_textbox = _resolveComponent("num-textbox")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_equipment_tree_list = _resolveComponent("equipment-tree-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_k_label, { for: "txtEqNo" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localize('EquipmentNo')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_num_textbox, {
        id: "txtEqNo",
        spinners: false,
        rounded: "full",
        format: "######",
        min: 1,
        max: 99999999,
        modelValue: _ctx.data.equipmentNo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.equipmentNo) = $event)),
        class: "txtEqNo"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_k_button, {
        id: "btnSubmit",
        rounded: "full",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localize('Search')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_checkbox, {
        id: "chkSparePartsOnly",
        modelValue: _ctx.data.onlySpareParts,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.onlySpareParts) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_k_label, { for: "chkSparePartsOnly" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.localize('OnlySpareParts')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.data.status != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ color: _ctx.data.status == _ctx.localize('NotFound') ? 'red' : 'black' })
        }, _toDisplayString(_ctx.localize(_ctx.data.status)), 5))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_equipment_tree_list, {
            bomData: _ctx.data.bomData
          }, null, 8, ["bomData"])
        ]))
  ], 64))
}